import { render, staticRenderFns } from "./DropdownConfig.vue?vue&type=template&id=f9ed1740&scoped=true"
import script from "./DropdownConfig.vue?vue&type=script&lang=js"
export * from "./DropdownConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ed1740",
  null
  
)

export default component.exports